import { ViewFactory } from 'wdc-cube-react'
import StatusProcessamentoScope from '../status_processamento.scopes'
import StatusProcessamentoView from './status_processamento.view'

export function registerViews(rv = ViewFactory.register) {
    rv(StatusProcessamentoScope, StatusProcessamentoView)
}
